<template>
    <div>
      <trademark-search-list></trademark-search-list>
    </div>
  </template>
  
  <script>
  
  export default {
  }
  </script>
  
  
  
  